<template>
  <!-- <div class="home-menu">
    <div class="menu-topbar">
      <div class="topbar-logo-box">
        <div class="box-logo">
          <img src="~@/assets/image/home/logo.png" class="logo" />
        </div>
        <div class="box-info" v-show="!isCollapse">
          <div class="info-product">豚小伴</div>
          <div class="info-schoolname">广州市长兴中学</div>
        </div>
      </div>
      <div class="topbar-drawer-box">
        <img src="~@/assets/image/home/drawer.png" class="drawer" />
      </div>
    </div>
    <div class="menu-main">

    </div>
  </div> -->
  <div class="home-menu">
    <div class="menu-topbar">
      <div class="topbar-logo-box" v-show="!isCollapse">
        <div class="box-logo">
          <el-image :src="school.logo || logo" fit="cover"></el-image>
        </div>
        <div class="box-info">
          <div class="info-product">豚小伴</div>
          <div class="info-schoolname-window">
            <div class="schoolname-box">{{ user.schoolName }}定制版</div>
          </div>
        </div>
      </div>
      <div class="topbar-drawer-box" @click="CloseMenu">
        <img src="~@/assets/image/home/drawer.png" class="drawer" />
      </div>
    </div>
    <el-menu :default-active="defaultActive" @select="handleSelect" class="el-menu-vertical-demo" :collapse="isCollapse"
      unique-opened router>
      <!-- 首页 -->
      <el-menu-item v-if="!isStudent" index="/home-page" class="home" ref="home">
        <i class="iconfont icon-home"></i>
        <span slot="title">首页</span>
      </el-menu-item>
      <!-- 其他 -->
      <el-submenu class="submenu-list" v-for="(item, index) in menuData" :key="index" :index="item.menuName">
        <template slot="title">
          <i class="iconfont" :class="`icon-${item.icon}`"></i>
          <span>{{ item.menuName }}</span>
        </template>
        <el-menu-item v-for="(childItem, childIndex) in item.childMenu" :key="childIndex" :index="childItem.path">
          <i class="iconfont" :class="`icon-${childItem.icon}`"></i>
          <span slot="title">{{ childItem.menuName }}</span>
        </el-menu-item>
      </el-submenu>
      <!-- <el-submenu
        class="submenu-list"
        v-for="(item, index) in menuData"
        :key="index"
        :index="item.menuItemName"
      >
        <template slot="title">
          <i class="iconfont" :class="`icon-${item.menuItemIcon}`"></i>
          <span>{{ item.menuItemName }}</span>
        </template>
        <el-menu-item
          v-for="(childItem, childIndex) in item.childItem"
          :key="childIndex"
          :index="childItem.path"
        >
          <i class="iconfont" :class="`icon-${childItem.itemIcon}`"></i>
          <span slot="title">{{ childItem.itemName }}</span>
        </el-menu-item>
      </el-submenu> -->
    </el-menu>
  </div>
</template>

<script>
import { getMenu } from "@/common/menu_list.js";
import { connect } from '@/common/wssocket';
import { websocketIP } from "@/api/request"; // 服务器地址

export default {
  props: ["menuData"],
  watch: {
    $route() {
      this.defaultActive = this.$route.path;
    },
  },
  data() {
    return {
      logo: require("@/assets/image/home/logo.png"),
      isCollapse: false,
      defaultActive: "",
      hasSelected: false, // 新增：用于标记是否已经调用过handleSelect
      // 菜单
      // menuData: [],
    };
  },
  computed: {
    // 检测是否为学生
    isStudent() {
      return this.user.jobList && this.user.jobList.includes('学生');
    }
  },
  created() {
    // 管理员
    // if (this.user.roleId == 1) {
    //   getMenu(1).then((res) => {
    //     this.menuData = res;
    //   });
    // } else {
    //   // 根据第一个班级的 isCharge（0：科任老师,1:班主任）来的角色生成菜单
    //   let roleId = "";
    //   if (
    //     this.classInfo.currentClass.courseList &&
    //     this.classInfo.currentClass.courseList.length
    //   ) {
    //     // 有科目 21：班主任(有科目) 31：科任老师(有科目)
    //     roleId = this.classInfo.currentClass.isCharge ? 21 : 31;
    //   } else {
    //     // 无科目 20：班主任(无科目) 30：科任老师(无科目)
    //     roleId = this.classInfo.currentClass.isCharge ? 20 : 30;
    //   }
    //   getMenu(roleId).then((res) => {
    //     this.menuData = res;
    //   });
    // }
    // getMenu().then((res) => {
    //   this.menuData = res;
    // });
    // console.log("this.menuData=>", this.menuData);
  },
  mounted() {
    // this.$refs.home.handleClick();
    this.defaultActive = this.$route.path;
  },
  methods: {
    CloseMenu() {
      this.isCollapse = !this.isCollapse;
    },
    chooseMenuItem(event) {
      console.log(event);
      this.defaultActive = event.path;

      // this.currentIndex = event.index;
    },
    // handleSelect() {
    //   if (!this.hasSelected && window.localStorage.getItem('bbfAdminTeacherToken')) {
    //     //  本地IP使用ws, 线上使用wss
    //     // connect(`ws://${websocketIP}:9123/im`, JSON.parse(window.localStorage.getItem('local_userInfo')).accessToken);
    //     connect(`wss://${websocketIP}:8878/im`, JSON.parse(window.localStorage.getItem('local_userInfo')).accessToken);
    //     this.hasSelected = true; // 第一次调用后设置为true
    //   }
    // }
    // 【核心修改】处理菜单选中逻辑
    // 【替换】新的 handleSelect 逻辑
    handleSelect(index, indexPath) {
      // index 是选中的菜单 path (如 '/publish-homework')

      // 1. 查找路由元信息以获取 title
      let title = index;
      if (index === '/home-page') {
        title = '首页';
      } else {
        // **方法一：使用 $router.match** (推荐，但需要确保路由已注册)
        // 这种方法可以匹配到已注册的任何路由，包括嵌套和异步加载的。
        const routeMatch = this.$router.match(index);

        if (routeMatch && routeMatch.name !== '404' && routeMatch.meta && routeMatch.meta.title) {
          title = routeMatch.meta.title;
        } else {
          // **方法二：安全遍历 constantRoutes** (备用/兜底)
          const allRoutes = this.$router.options.routes;
          let routeInfo = null;

          // 遍历所有顶层路由及其 children
          allRoutes.forEach(route => {
            // 检查当前顶层路由是否匹配
            if (route.path === index && route.meta && route.meta.title) {
              routeInfo = route;
            }
            // 检查子路由
            if (route.children) {
              const childMatch = route.children.find(c => c.path === index);
              if (childMatch) {
                routeInfo = childMatch;
              }
            }
          });

          if (routeInfo && routeInfo.meta && routeInfo.meta.title) {
            title = routeInfo.meta.title;
          }
        }
      }

      // 2. 更新 Vuex tableTabs 状态
      if (title && index) {
        // 注意：这里使用 'tabs/ADD_TAB'
        this.$store.commit('tableTabs/ADD_TAB', {
          title: title,
          path: index
        });
        // 由于 el-menu 带有 router 属性，它会自动跳转路由，我们不再需要手动 push。
      }

      // 3. 原来的 WebSocket 连接逻辑 (保持不变)
      if (!this.hasSelected && window.localStorage.getItem('bbfAdminTeacherToken')) {
        // ... (原有的 connect 逻辑)
        connect(`wss://${websocketIP}:8878/im`, JSON.parse(window.localStorage.getItem('local_userInfo')).accessToken);
        this.hasSelected = true;
      }
    }
  },
};
</script>

<style scoped lang="scss">
@import "./homeMenu.scss";
</style>
